<template>
    <b-card no-body>
        
            <b-modal id="create-or-update" :title="editing ? 'Güncelle' : 'Oluştur'" no-close-on-esc no-close-on-backdrop>
                <ohs-education-create-or-update v-model="education" :errors="errors"></ohs-education-create-or-update>
                <template #modal-footer><v-executer :loading="loading" :editing="editing" :action="createOrUpdate"></v-executer></template>
            </b-modal>
        
            <v-table    ref="table"
                        :buttons="buttons"
                        :fields="fields"
                        pagination="server"
                        search
                        :items-provider="provider"
                        :add-callback="createNew"></v-table>
    </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import OHSEducationCreateOrUpdate from './components/OHSEducationCreateOrUpdate.vue'
import OHSEducationApi from '@/api/ohs-education'

export default {
    components:{
        BCard,
        'ohs-education-create-or-update':OHSEducationCreateOrUpdate
    },
    data(){
        return{
            fields:[
                {name:"Tehlike Sınıfı",key:"HazardClassName", thClass:"w-50",sortable:true},   
                {name:"İSG Eğitimi",key:"Name", thClass:"w-50",sortable:true},   
            ],
            buttons:[
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
            ],
            editing:false,
            errors:{},
            loading:false,
            education:{
                Id:null,
                Name:null,
                HazardClassId:null
            }
        }
    },
    methods:{
        clearForm(){
            this.editing = false
            this.education.Id = null
            this.education.Name = null
            this.education.HazardClassId = null
        },
        createNew(){
            this.clearForm()
            this.$showModal('create-or-update')
        },
        provider(data){
            return OHSEducationApi.Table(data)
        },
        edit(item){
            this.clearForm()
            this.editing = true
            this.education.Id = item.Id
            this.education.Name = item.Name
            this.education.HazardClassId = item.HazardClassId
            this.$showModal('create-or-update')
        },
        createOrUpdate(){
            this.loading = true
            OHSEducationApi.CreateOrUpdate(this.editing,this.education).then(res=>{
                this.$result(res)
                this.loading = false
                if(res.data.Success){
                    this.$hideModal('create-or-update')
                    this.$refs.table.refresh()
                }
            }).catch(err=>{
                this.loading = false
                this.$result(null,err)
            })
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.Name} isimli İSG eğitimini silecektir ve geri alınamaz.`).then(result=>{
                if(result){
                    OHSEducationApi.Delete(item.Id).then(res=>{
                        if(res.data.Success) {
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err=>{
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>